import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
    width: 100%;

    ${theme.below.mobileL`
      margin-top: ${theme.newSpaces.xl3}px;
        .table-wrapper {
          padding: 0px ${theme.newSpaces.lg}px;

          & > div {
            padding: 0px;
          }
        }
    `}
  `}
`

export const ContentWrapper = styled.div`
  margin-top: ${({ theme }) => theme.newSpaces.xl2}px;
`

export const Container = styled.div`
  ${({ theme }) => css`
    column-gap: ${theme.newSpaces.xs2}px;
    display: grid;
    grid-auto-rows: 1fr;
    grid-row-gap: ${theme.newSpaces.xs2}px;
    grid-template-columns: 60% 40%;
    margin: ${theme.newSpaces.xl2}px auto;

    ${theme.below.laptop`
      padding: 0px ${theme.newSpaces.sm}px;
    `}

    ${theme.below.tablet`
      grid-template-columns: repeat(1, 1fr);
    `}
  `}
`

export const SectionItem = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.colors.backLight};
    display: flex;
    flex-direction: row;
    padding: ${theme.newSpaces.xs}px ${theme.newSpaces.md}px;

    .image {
      margin-right: ${theme.newSpaces.md}px;
    }

    ${theme.below.mobileXL`
      align-items: flex-start;
    `}

    ${theme.below.mobileM`
      padding: ${theme.newSpaces.xs2}px ${theme.newSpaces.md}px;
    `}
  `}
`

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.newColors.primary};

    ${theme.below.tablet`
      margin-bottom:  ${({ theme }) => theme.newSpaces.xs}px;
      text-transform: uppercase;
    `}

    ${theme.below.mobileL`
      font-size: ${theme.typography.mobile.body.body1.fontSize}px;
      margin-bottom:  ${({ theme }) => theme.newSpaces.xs2}px;
    `}
  `}
`

export const Text = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
    font-weight: ${theme.typography.mobile.body.body2.fontWeight};

    & > a {
      font-size: ${theme.typography.desktop.body.body2.fontSize}px;
    }

    ${theme.below.mobileL`
      font-size: ${theme.typography.mobile.body.body3.fontSize}px;

      & > a {
        font-size: ${theme.typography.mobile.body.body3.fontSize}px;
      }
    `}
  `}
`
